import React, { useState, useCallback, useEffect } from 'react';
import {
  getCookieData,
  removeCookieData,
  updateOnFitStatusChange,
  updateProductListingOnRackSelect,
  updateProductDetailOnRackSelect,
} from './Hooks/hooks';

import { UpdateFitAssistantPriceAndATC, getIconClassByFitAssistantStatus } from '../FitAssistantShared/Functions';

import StatusEnum from './Enums/StatusEnum';
import StepEnum from './Enums/StepEnum';
import Modal from './Modal';
import { onRackSelectorOpen } from './Utils/Tracking';

const FitGuideRacks = ({ data }) => {
  const [fitStatus, setFitStatus] = useState(StatusEnum.NoSelection);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [requiredAdapter, setRequiredAdapter] = useState(null);
  const [step, setStep] = useState(StepEnum.RackSelect);

  useEffect(() => {
    var cookie = getCookieData();
    if (!cookie) return;

    if (cookie.name) setSelectedProduct(cookie.name);
    setStep(StepEnum.RackSelect);
    if (!(cookie.index >= 0)) {
      updateOnFitStatusChange(cookie.fitStatus);
    } else {
      let fitStatusFromSelection;
      if (window.location.href.indexOf('-_-') === -1) {
        let filterclassNames = window._THULEDATA.FitGuideRacksData.FilterItems[cookie.index].FilterClassNames;
        fitStatusFromSelection = updateProductListingOnRackSelect(fitStatusFromSelection, filterclassNames);
      } else {
        let filterInformation = window._THULEDATA.FitGuideRacksData.FilterItems[cookie.index].FilterInformation;
        fitStatusFromSelection = updateProductDetailOnRackSelect(fitStatusFromSelection, filterInformation);
        if (cookie.adapter) {
          setRequiredAdapter(cookie.adapter);
        } else if (filterInformation?.AdapterName) {
          setRequiredAdapter(filterInformation.AdapterName);
        }
      }
      setFitStatus(fitStatusFromSelection);
    }
  }, []);

  const handleReset = useCallback(() => {
    setFitStatus(StatusEnum.NoSelection);
    setSelectedProduct(null);
    setStep(StepEnum.RackSelect);
    setRequiredAdapter(null);
    updateOnFitStatusChange(StatusEnum.NoSelection);
    removeCookieData();

    const productIdsForSolution = document.querySelector('#productBuyArea .product-ids-for-solution')?.dataset
      ?.defaultids;
    if (productIdsForSolution) {
      const productIds = productIdsForSolution.split(',');
      UpdateFitAssistantPriceAndATC(productIds);
    }
  }, [fitStatus, selectedProduct, step]);

  const handleStepSelect = useCallback(
    (stepEnumValue) => {
      if (stepEnumValue === StepEnum.ThirdParty) setSelectedProduct(null);
      setStep(stepEnumValue);
    },
    [step]
  );

  const handleProductSelect = useCallback(
    (productName, status, adapter) => {
      setSelectedProduct(productName);
      setRequiredAdapter(adapter ?? null);
      setFitStatus(status);
      setIsModalVisible(false);
    },
    [selectedProduct]
  );

  const handleNonThuleRack = useCallback(
    (status) => {
      setFitStatus(status);
      setIsModalVisible(true);
    },
    [fitStatus]
  );

  const getStatusLabel = () => {
    let label = '';
    switch (fitStatus) {
      case StatusEnum.NoSelection:
        label = '';
        break;
      case StatusEnum.Confirmed:
        label = data.Translations.Confirmed;
        break;
      case StatusEnum.Unconfirmed:
        label = data.Translations.Unconfirmed;
        break;
      case StatusEnum.NoFit:
        label = data.Translations.NoFit;
        break;
    }
    return label;
  };

  const getCategoryUrl = () => {
    if (document.getElementById("REACT_buyersguide")) {
      let url = new URL(window.location);
      let params = new URLSearchParams(url.search);
      params.set('dbg_sc', data.CategoryId);
      return `${url.origin}${url.pathname}?${params.toString()}`;
    }
    return data.CategoryLink;
  }

  return (
    <>
      <div
        className="fit-guide-racks"
        onClick={() => {
          setIsModalVisible(true);
          onRackSelectorOpen();
          document.dispatchEvent(new Event('faOpened'));
        }}
      >
        <h5 className="heading5 mb-5">
          {data.Translations.Fit ?? 'Fit'}
          {fitStatus !== StatusEnum.NoSelection && <span className="fit-status">{getStatusLabel()}</span>}
        </h5>
        <div className={`fit-guide-button d-flex`}>
          {<i className={`fit-indicator ${fitStatus} ${getIconClassByFitAssistantStatus(fitStatus)}`}></i>}
          <span className={`heading6 text-color--black fit-guide-span ms-3`}>
            {selectedProduct
              ? selectedProduct
              : fitStatus === StatusEnum.Unconfirmed
                ? data.Translations.Unconfirmed
                : data.Translations.AddRoofRack}
          </span>
          {fitStatus === StatusEnum.NoSelection && <i className="le-icon-arrow rot-180"></i>}
        </div>
        {requiredAdapter && window._THULEDATA.ProductDetail && (
          <div className="mt-5">
            <span>{data.Translations.IncludedToFit}</span>
            <ul>
              <li>{window._THULEDATA.ProductDetail.Webtitle1 ?? window._THULEDATA.ProductDetail.ProductName}</li>
              <li>{requiredAdapter}</li>
            </ul>
          </div>
        )}
      </div>
      <Modal
        categoryLink={getCategoryUrl()}
        translations={data.Translations}
        filters={data.FilterItems}
        isVisible={isModalVisible}
        setVisibility={setIsModalVisible}
        step={step}
        handleStepSelect={handleStepSelect}
        handleReset={handleReset}
        handleProductSelect={handleProductSelect}
        handleNonThuleRack={handleNonThuleRack}
        selectedProduct={selectedProduct}
        imageUrl={data.ThirdPartyRacksImageUrl}
        imageAlt={data.ThirdPartyRacksImageAlt}
      />
    </>
  );
};

export default FitGuideRacks;
